import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col, Container, Alert, Collapse } from 'reactstrap';
import { Form } from '@availity/form';
import { Input, Date, Select, Checkbox, Radio } from '../../lib/form-field';
import * as yup from 'yup';
import '@availity/yup';
import { withRouter, Link } from 'react-router-dom';
import * as authActions from '../../store/auth/actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  emptyObjectKeys,
  emptyObject,
  filterObject,
} from '../../helpers/sharedFunction';
import Footer from '../../components/Authentication/Footer';

import heroImg from '../../assets/images/doctor-real-on-phone-male-couple.webp';
import logo from '../../assets/images/logo-dark.png';

import italianCities from '../../lib/italianCities.json';

const FIRST_STEP_FIELDS = [
  'firstName',
  'lastName',
  'phone',
  'email',
  'password',
  'confirmPassword',
];

const INITIAL_VALUES =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? {
        firstName: 'Enrico',
        lastName: 'Bianchi',
        email: 'enrico.bianchi17@mediadatafactory.com',
        password: 'password',
        confirmPassword: 'password',
        phone: '+393333333333',
        birthDate: '1990-01-01',
        city: 'RM',
      }
    : {};

const Register = ({ history }) => {
  const error = useSelector((state) => state.Auth.error);
  const success = useSelector((state) => state.Auth.success);

  const [step, setStep] = useState(1);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.resetMessages());
  }, []);

  const handleFormButton = useCallback(() => {
    if (step === 1) {
      setStep(2);
    }
  }, [step]);

  const isPartiallyValid = useCallback((values = {}, errors = {}) => {
    values = filterObject(values, FIRST_STEP_FIELDS);
    errors = filterObject(errors, FIRST_STEP_FIELDS);
    return !emptyObjectKeys(values) && emptyObject(errors);
  }, []);

  const handleValidSubmit = (values) => {
    delete values.termsConsent;

    const { email, password, ...rest } = values;
    if (!(email && password)) {
      return;
    }

    const displayName = `${rest.firstName} ${rest.lastName}`;

    dispatch(
      authActions.registerWithEmail(
        { email, password, displayName, ...rest },
        history,
      ),
    );
  };

  return (
    <div className="home" style={{ minHeight: '100vh', background: '#fff' }}>
      <Container>
        <Row
          className="align-items-center"
          style={{ minHeight: 'calc(100vh - 80px)' }}>
          <Col
            lg={6}
            className="d-none d-lg-flex justify-content-center align-items-center"
            style={{ background: '#f7fafc', minHeight: '70vh' }}>
            <img
              src={heroImg}
              alt="Telemedicina"
              style={{ maxWidth: '80%', height: 'auto' }}
            />
          </Col>
          <Col
            lg={6}
            md={12}
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ padding: '3rem 1rem' }}>
            <Link to="/index">
              <img
                src={logo}
                alt="SOS Dottore"
                style={{ maxWidth: 220, marginBottom: 32 }}
              />
            </Link>
            <h1
              style={{
                fontSize: '2.5rem',
                fontWeight: 700,
                color: '#22313f',
                textAlign: 'center',
                marginBottom: 8,
              }}>
              Crea il tuo account
            </h1>
            <p
              style={{
                fontSize: '1.15rem',
                color: '#4a5a6a',
                marginBottom: 32,
                textAlign: 'center',
                maxWidth: 400,
              }}>
              Iscriviti per abbonarti a SOS Dottore e accedere ai servizi di
              telemedicina
            </p>
            <div style={{ width: '100%', maxWidth: 400 }}>
              {error !== '' && <Alert color="danger">{error}</Alert>}
              {success !== '' && <Alert color="success">{success}</Alert>}
              {step === 2 && (
                <div className="d-flex justify-content-end mb-2">
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    type="button"
                    onClick={() => setStep(1)}>
                    <i className="mdi mdi-arrow-left mr-1" />
                    Torna indietro
                  </button>
                </div>
              )}
              <Form
                className="form-horizontal"
                onSubmit={handleValidSubmit}
                initialValues={INITIAL_VALUES}
                validationSchema={yup.object().shape({
                  firstName: yup.string().required(),
                  lastName: yup.string().required(),
                  phone: yup
                    .string()
                    .required()
                    .matches(
                      /^(\+39)?[3][0-9]{8,9}$/,
                      'Inserisci un numero di cellulare italiano valido',
                    ),
                  email: yup.string().email().required(),
                  password: yup.string().required(),
                  confirmPassword: yup
                    .string()
                    .required()
                    .oneOf(
                      [yup.ref('password'), null],
                      'Le password non corrispondono',
                    ),
                  birthDate: yup.string().required(),
                  city: yup.string().required(),
                  termsConsent: yup
                    .array()
                    .required()
                    .min(1)
                    .of(yup.string().oneOf(['yes'])),
                  marketingConsent: yup.string().required(),
                  profilingConsent: yup.string().required(),
                })}>
                {({ values, isValid, errors }) => {
                  return (
                    <>
                      <Collapse isOpen={step === 1}>
                        <div className="form-group">
                          <Input
                            name="firstName"
                            label="Nome"
                            type="text"
                            placeholder="Inserisci il tuo nome"
                          />
                        </div>
                        <div className="form-group">
                          <Input
                            name="lastName"
                            label="Cognome"
                            type="text"
                            placeholder="Inserisci il tuo cognome"
                          />
                        </div>
                        <div className="form-group">
                          <Input
                            name="phone"
                            label="Telefono"
                            type="text"
                            placeholder="Inserisci il tuo numero di telefono"
                          />
                        </div>
                        <div className="form-group">
                          <Input
                            name="email"
                            label="Email"
                            placeholder="Inserisci la tua email"
                            type="email"
                          />
                        </div>
                        <div className="form-group">
                          <Input
                            name="password"
                            label="Password"
                            type="password"
                            placeholder="Crea una password"
                          />
                        </div>
                        <div className="form-group">
                          <Input
                            name="confirmPassword"
                            label="Conferma password"
                            type="password"
                            placeholder="Conferma la tua password"
                          />
                        </div>
                        <button
                          className="btn btn-primary btn-block"
                          type="button"
                          onClick={() => handleFormButton()}
                          disabled={!isPartiallyValid(values, errors)}
                          style={{
                            padding: '0.75rem',
                            fontSize: '1.15rem',
                            fontWeight: 600,
                            borderRadius: 8,
                            background: '#1e6f5c',
                            border: 'none',
                          }}>
                          Avanti
                        </button>
                      </Collapse>
                      <Collapse isOpen={step === 2}>
                        <div className="form-group">
                          <Date
                            name="birthDate"
                            label="Data di nascita"
                            type="date"
                            placeholder="Inserisci la tua data di nascita"
                          />
                        </div>
                        <div className="form-group">
                          <Select
                            name="city"
                            label="Provincia"
                            options={italianCities.map(({ nome, sigla }) => ({
                              label: nome,
                              value: sigla,
                            }))}
                            placeholder="Inserisci la tua provincia"
                          />
                        </div>
                        <div className="form-group mb-4">
                          <Checkbox name="termsConsent">
                            <label
                              className="ml-2"
                              style={{
                                fontSize: '0.8rem',
                                color: '#4a5a6a',
                                lineHeight: '1.5',
                              }}>
                              Dichiaro di aver letto ed accettato l'Informativa
                              riportata{' '}
                              <a
                                href="https://www.iubenda.com/privacy-policy/21991191/legal"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: '#1e6f5c',
                                  textDecoration: 'underline !important',
                                }}>
                                qui
                              </a>{' '}
                              e di voler conferire i miei dati personali ai fini
                              dell'iscrizione al sito, per ottenere i servizi
                              previsti e ricevere informazioni di carattere
                              editoriale e promozionale, riguardanti famiglia,
                              maternità e infanzia. Dichiaro di essere
                              maggiorenne e di aver letto e accettato i{' '}
                              <a
                                href="https://www.iubenda.com/termini-e-condizioni/21991191"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: '#1e6f5c',
                                  textDecoration: 'underline !important',
                                }}>
                                Termini e Condizioni
                              </a>{' '}
                              del sito e le{' '}
                              <a
                                href="https://firebasestorage.googleapis.com/v0/b/sos-dottore.firebasestorage.app/o/contratti%2FInformazioni%20Generali%20e%20Condizioni%20di%20servizio%20DOC24%20BASE_MDF_180_def.pdf?alt=media&token=b37c082f-ac7c-49f2-ad8c-196337be7e94"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: '#1e6f5c',
                                  textDecoration: 'underline !important',
                                }}>
                                Informazioni generali e Condizioni di Servizio
                              </a>
                            </label>
                          </Checkbox>
                        </div>

                        <div className="form-group mb-4">
                          <Radio
                            name="marketingConsent"
                            labels={['Sì', 'No']}
                            values={['yes', 'no']}>
                            <label
                              style={{
                                fontSize: '0.8rem',
                                color: '#4a5a6a',
                                lineHeight: '1.5',
                              }}>
                              Consento il trattamento dei dati personali forniti
                              a SosDottore.it per partecipare a ricerche di
                              mercato, per ricevere informazioni e offerte
                              promozionali tramite posta, telefono, posta
                              elettronica, sms, mms da parte di Aziende Terze,
                              indicate nell'informativa riportata{' '}
                              <a
                                href="https://www.iubenda.com/privacy-policy/21991191/legal"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: '#1e6f5c',
                                  textDecoration: 'underline !important',
                                }}>
                                qui
                              </a>
                              .
                            </label>
                          </Radio>
                        </div>

                        <div className="form-group mb-4">
                          <Radio
                            name="profilingConsent"
                            labels={['Sì', 'No']}
                            values={['yes', 'no']}>
                            <label
                              className="form-label mb-3"
                              style={{
                                fontSize: '0.8rem',
                                color: '#4a5a6a',
                                fontWeight: '500',
                              }}>
                              Consento il trattamento dei miei dati forniti a
                              SosDottore.it per effettuare attività di
                              profilazione ai fini di marketing da parte dei
                              Titolari del sito, per analizzare o prevedere
                              aspetti riguardanti la mia persona e utilizzare
                              tali dati come precisato nella informativa
                              riportata{' '}
                              <a
                                href="https://www.iubenda.com/privacy-policy/21991191/legal"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: '#1e6f5c',
                                  textDecoration: 'underline !important',
                                }}>
                                qui
                              </a>
                              .
                            </label>
                          </Radio>
                        </div>
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={!isValid}
                          style={{
                            padding: '0.75rem',
                            fontSize: '1.15rem',
                            fontWeight: 600,
                            borderRadius: 8,
                            background: '#1e6f5c',
                            border: 'none',
                          }}>
                          Registrati
                        </button>
                      </Collapse>
                      <div className="text-center mt-4">
                        <span style={{ color: '#4a5a6a', fontSize: '1rem' }}>
                          Hai già un account?{' '}
                          <Link
                            to="/login"
                            style={{ color: '#1e6f5c', fontWeight: 600 }}>
                            Accedi
                          </Link>
                        </span>
                      </div>
                    </>
                  );
                }}
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default withRouter(Register);
